import { MainContentWrapper } from '@ydistri/ds';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { setSubpage } from '../../../routes/routerSlice';
import { useAppDispatch } from '../../../store';
import { ProjectAdministrationSubpage } from '../projectAdministrationLib';
import AiPromptsSection from './AiPromptsSection';

const AiPromptsAdministration: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setSubpage(ProjectAdministrationSubpage.AI_PROMPTS));
  }, [dispatch]);

  return (
    <>
      <Helmet title="AI Prompts Administration" />
      <MainContentWrapper>
        <AiPromptsSection />
      </MainContentWrapper>
    </>
  );
};

export default AiPromptsAdministration;
